import { render, staticRenderFns } from "./ContactInformationDisplay.vue?vue&type=template&id=669d75e4&scoped=true&"
import script from "./ContactInformationDisplay.vue?vue&type=script&lang=js&"
export * from "./ContactInformationDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ContactInformationDisplay.vue?vue&type=style&index=0&id=669d75e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d75e4",
  null
  
)

export default component.exports